export default {
  visibility: {
    update: (el, binding, vnode) => {
      el.style.visibility = binding.value ? 'visible' : 'hidden'
    }
  }
}
